export default "__VITE_ASSET__8Zar2fct__"